
<template v-else>
  <v-layout column class="page pagemargin">
    <!-- SPONSOR PAGE -->
    <div v-if="parseInt(user.userLevel) === 10">
      <v-layout column>
        <v-flex sm12 align-center justify-center class="device-main-game-report text-xs-center">
          <v-layout row wrap>
            <v-flex md12 class="select-container">
              <v-card>
                <v-toolbar color="secondary">
                  <v-toolbar-title
                    class="report-title font-weight-thin white--text"
                  >{{sName}} Report for {{gName}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="selected"
                    :items="sortedGames"
                    item-text="gameName"
                    item-value="id"
                    attach
                    chips
                    dark
                    label="Games"
                    @input="selectGame(selected)"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.gameName }} on {{ formatDate(data.item.date, "YYYY-MM-DD", "DD-MMM-YY") }}</template>
                    <template slot="item" slot-scope="data">
                      <template>
                        <span style="font-weight: bold">{{ data.item.gameName }}</span> &nbsp; on &nbsp;
                        <span
                          style="font-weight: bold"
                        >{{ formatDate(data.item.date, "YYYY-MM-DD", "DD-MMM-YY") }}</span>
                      </template>
                    </template>
                  </v-select>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout fluid row wrap>
            <!--Video-->
            <v-flex xs12 md7>
              <v-card class="game-player" height="100%">
                <GamePlayer :options="videoOptions" />
              </v-card>
            </v-flex>
            <!--Tabs-->
            <v-flex d-flex xs12 md5>
              <v-card>
                <GameTabs />
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <!-- CLUB PAGE -->
    <div v-else>
      <v-content class="club-page-container">
        <!-- GAME LIST -->
        <!-- title -->
        <v-toolbar color="secondary" v-if="!gameHidden">
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              :class="{
              'text-xs-center': $vuetify.breakpoint.smAndDown
            }"
            >
              <span class="page-title font-weight-thin white--text">Select a game to view report</span>
            </v-flex>
          </v-layout>
        </v-toolbar>

        <!-- Vue Good Table - Start -->
        <vue-good-table
          v-if="!gameHidden"
          ref="my-table"
          :columns="Columns"
          :rows="rows"
          :sort-options="SortOptions"
          :search-options="SearchOptions"
          :pagination-options="Pagination"
          style-class="vgt-table condensed bordered striped"
          row-style-class="tablerowheight"
          class="sponsor-report-table"
        >
          <template slot="table-column" slot-scope="props">
            <span class="tablerowheight">{{ props.column.label }}</span>
          </template>
          <!-- actions -->
          <template slot="table-row" slot-scope="props" class="vgt-right-align">
            <span v-if="props.column.field == 'action'">
              <v-btn
                round
                style="height: 70%; padding:1% !important"
                color="primary"
                @click="openSelect(props.row.id); gameHidden=true; sponsorsHidden= !sponsorsHidden"
              >GO</v-btn>
            </span>
          </template>
        </vue-good-table>
        <!-- Vue Good Table - End -->

        <!-- SELECT GAME -->
        <!--
        <v-layout row wrap align-center v-if="!gameHidden" class="selectGameDiv">
          <v-flex xs12 class="gameSelector">
            <v-select
              v-model="selected"
              :items="games"
              item-text="gameName"
              item-value="id"
              attach
              label="Games"
              @input="openSelect(selected); gameHidden=true; sponsorsHidden= !sponsorsHidden"
            ></v-select>
          </v-flex>
        </v-layout>-->
        <!-- SPONSOR LIST -->
        <!-- title -->
        <v-toolbar color="secondary" v-if="sponsorsHidden">
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              :class="{
              'text-xs-center': $vuetify.breakpoint.smAndDown
            }"
            >
              <span class="page-title font-weight-thin white--text">
                Select a sponsor for the game
                <br />
                <strong>{{gName}} on {{ formatDate(gDate, "YYYY-MM-DD", "DD-MMM-YY") }}</strong>
              </span>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <!--list-->
        <v-layout column>
          <v-flex
            v-if="sponsorsHidden"
            sm12
            align-center
            justify-center
            class="device-main-game-report text-xs-center"
          >
            <v-flex xs12 sm12 md12 class="sponsor-list">
              <v-layout row wrap align-center justify-center>
                <v-flex
                  v-for="sponsor in sponsors"
                  :key="sponsor.name"
                  xs5
                  sm2
                  md2
                  class="individual-spon-btn ma-1 mb-3"
                >
                  <v-card
                    v-if="sponsorsHidden"
                    v-on:click="openSponsorReport(sponsor.id, gID, sponsor.name); sponsorsHidden = false; reportHidden = !reportHidden"
                    class="game-card"
                  >
                    <v-img
                      v-bind:src="createURL(sponsor.icon.handle)"
                      height="130px"
                      width="150px"
                      style="margin:auto; text-align:center;"
                    ></v-img>
                    <v-card-text class="primary sponsor-name white--text">{{sponsor.name}}</v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <br />
            <br />
            <br />
          </v-flex>
        </v-layout>

        <!-- SPONSOR REPORT -->
        <!-- title -->
        <v-toolbar color="secondary" v-if="reportHidden">
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              :class="{
              'text-xs-center': $vuetify.breakpoint.smAndDown
            }"
            >
              <span
                class="page-title font-weight-thin white--text"
              >{{gName}} on {{ formatDate(gDate, "YYYY-MM-DD", "DD-MMM-YY") }} - {{sName}} Report</span>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <!--content-->
        <v-layout column>
          <v-flex
            v-if="reportHidden"
            sm12
            align-center
            justify-center
            class="device-main-game-report text-xs-center"
            style="margin-bottom: 70px !important"
          >
            <v-layout fluid row wrap>
              <!--Video-->
              <v-flex xs12 md7>
                <v-card class="game-player" height="100%">
                  <GamePlayer :options="videoOptions" />
                </v-card>
              </v-flex>
              <!--Tabs-->
              <v-flex d-flex xs12 md5>
                <v-card>
                  <GameTabs />
                </v-card>
              </v-flex>
            </v-layout>
            <!--<v-flex v-if="reportHidden" md12 align-center justify-center class="text-xs-center">
              <v-card>
                <Timeline v-if="!isMobile()" />
              </v-card>
            </v-flex>-->
          </v-flex>
        </v-layout>
      </v-content>
      <v-content>
        <v-flex md12>
          <!-- bottom navigation -->
          <v-bottom-nav :active.sync="bottomNav" :value="true" fixed color="white">
            <v-btn
              color="primary"
              flat
              value="favorites"
              class="back-btn"
              v-if="sponsorsHidden"
              v-on:click="gameHidden = false; sponsorsHidden = !sponsorsHidden"
            >
              <span color="primary">Back</span>
              <v-icon color="primary">icons8-sort-left</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              flat
              value="recent"
              class="back-btn"
              v-if="reportHidden"
              v-on:click="sponsorsHidden = true; reportHidden = !reportHidden"
            >
              <span color="primary">Back</span>
              <v-icon color="primary">icons8-sort-left</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              flat
              v-on:click="gameHidden = false; sponsorsHidden = false; reportHidden= false"
            >
              <span color="primary">Games</span>
              <v-icon color="primary">icons8-stadium</v-icon>
            </v-btn>
          </v-bottom-nav>
        </v-flex>
      </v-content>
    </div>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import GamePlayer from "@/components/games/GamesPlayer.vue";
import GameTabs from "@/components/games/GamesTabs.vue";
import Timeline from "@/components/charts/SponsorsReportTimeline.vue";
import { filestack } from "@/components/mixins/filestack.js";
import adminSchema from "@/schemas/admin.json";

export default {
  mixins: [filestack],
  components: {
    GamePlayer,
    GameTabs,
    Timeline
  },
  props: {},
  data() {
    return {
      bottomNav: "recent",
      selected: "",
      games: [],
      sortedGames: [],
      sponsors: [],
      portalList: [],
      gameHidden: false,
      sponsorsHidden: false,
      reportHidden: false,
      isSponsor: false,
      videoOptions: {
        controls: true,
        sources: [
          {
            src: ""
          }
        ]
      },
      rows: [],
      Pagination: {
        enabled: true,
        mode: "records",
        perPage: 12,
        setCurrentPage: 1,
        position: "bottom",
        perPageDropdown: [5, 10, 20, 30, 40, 50],
        dropdownAllowAll: true,
        nextLabel: "Next",
        prevLabel: "Prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "Page", // for "pages" mode
        allLabel: "All"
      },

      SearchOptions: { enabled: true },
      SortOptions: {
        enabled: false
        // initialSortBy: { field: "id", type: "asc" }
      }
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      Sponsors: state => state.Admin.OtherDocuments,
      reportResult: state => state.report.result,
      sName: state => state.report.sponsorName,
      gName: state => state.report.gameName,
      gID: state => state.report.gameID, // game report store
      sID: state => state.report.sponsorID,
      user: state => state.user.active,
      clip: state => state.clip,
      gameVideoLink: state => state.game.videoLink,
      gameID: state => state.game.gameID, // from game store
      sponByGameResult: state => state.clip.sponByGameResult,
      gDate: state => state.report.gameDate
    }),
    sortGame: function() {
      return (this.sortedGames = this.games);
    },
    color() {
      switch (this.bottomNav) {
        case 0:
          return "primary";
        case 1:
          return "primary";
        case 2:
          return "primary";
        case 3:
          return "primary";
      }
    },
    Columns() {
      return adminSchema.sponsorReportPickList.columns;
    }
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
        this.rows = this.Documents;
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    },
    Sponsors: {
      handler: function() {
        this.sponsors = this.Sponsors;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    OtherDocumentsResult: {
      handler: function() {
        this.readSponsors();
      },
      deep: true
    },
    gameVideoLink: {
      handler: function() {
        this.videoOptions.sources = [
          {
            controls: false,
            src: this.createURL(this.gameVideoLink.handle),
            type: "video/mp4",
            preload: "auto"
          }
        ];
      },
      //immediate: true,
      deep: true
    }
  },
  methods: {
   formatDate: function(value, formatIn, formatOut) {
      return this.$moment(value, formatIn).format(formatOut);
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    readSponsors() {
      this.$store.dispatch("Admin/readOtherDocuments", [
        "sponsors",
        this.portal.active.id,
        "Admin/setOtherDocuments"
      ]);
    },
    openSelect(gameID) {
      console.log("GAME id: " + gameID);
      var i = 0;
      var j = 0;
      var sponsorID = {};
      var gameName = "";
      var gameDate = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (gameID === this.Documents[i].id) {
          sponsorID = this.Documents[i].sponsorID;
          gameName = this.Documents[i].gameName;
          gameDate = this.Documents[i].date;
           // this.$store.commit("report/setValue", ["gameDate", gameDate]);
          this.$store.commit("game/setValue", [
            "videoLink",
            this.Documents[i].videoLink
          ]);
        }
      }


      // console.log(
      //   "game video link: " + JSON.stringify(this.videoOptions, null, 2)
      // );
      var newSponsorList = [];
      for (i = 0; i < this.Sponsors.length; i++) {
        for (j = 0; j < sponsorID.length; j++) {
          if (sponsorID[j] === this.Sponsors[i].id) {
            newSponsorList.push(this.Sponsors[i]);
            this.sponsors = newSponsorList;
            this.$store.commit("report/setValue", ["gameName", gameName]);
            this.$store.commit("report/setValue", ["gameID", gameID]);
            this.$store.commit("report/setValue", ["gameDate", gameDate]);
          }
        }
      }

                  console.log("GAME DATE: " + gameDate);

    },
    openSponsorReport(sponsorID, gameID, sponsorName) {
      var i = 0;
      // console.log("GAME ID ON BUTTON: " + gameID);
      for (i = 0; i < this.Sponsors.length; i++) {
        if (sponsorID === this.Sponsors[i].id) {
          // this.sponsors[i].sponsorName = this.Sponsors[i].name;
          this.$store.commit("report/setValue", ["sponsorName", sponsorName]);
          this.$store.commit("report/setValue", ["sponsorID", sponsorID]);
          this.$store.commit("report/setValue", ["gameID", gameID]);
          //this.$store.commit("report/setValue", ["gameDate", gameDate]);

        }
      }
      // console.log("SPONSOR ID ON BUTTON: " + sponsorID);
      this.$store.dispatch(
        "report/sendReportData",
        [sponsorID, gameID],
        "report/setReportData"
      );
      //  //update table on select
      // this.$store.dispatch("clip/getClipsByStatusAndGame", [
      //   "clips",
      //   this.portal.active.id,
      //   this.gameID,
      //   "Draft",
      //   "clip/setSponByGameResult"
      // ]);
      // console.log(
      //     "Report result: " + JSON.stringify(this.reportResult, null, 2)
      //   );
    },
    sortGamesByDate() {
      this.games.sort(function(a, b) {
        var dateA = new Date(a.date);
        var dateB = new Date(b.date);
        return dateB - dateA;
      });
    },
    sortGamesBySponsor() {
      var i = 0;
      var j = 0;
      this.games = [];
      var docs = this.games;
      for (i = 0; i < this.Documents.length; i++) {
        for (j = 0; j < this.Documents[i].sponsorID.length; j++) {
          if (this.user.sponsorID === this.Documents[i].sponsorID[j]) {
            docs.push(this.Documents[i]);
          }
        }
      }
      this.games = docs;
      return this.games;
    },
    selectGame(gameID) {
      // console.log("Selected: " + gameID);
      this.$store.commit("report/setValue", ["gameID", gameID]);
      // update more info tab after select
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
      // update review after select
      this.$store.dispatch("clip/getSponsorClipsByGame", [
        "clips",
        this.portal.active.id,
        this.sID,
        this.gID,
        "clip/setSponByGameResult"
      ]);
      //change the game name and videolink dynamically
      var i = 0;
      var gameName = "";
      var gameDate = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (gameID === this.Documents[i].id) {
          gameName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", ["gameName", gameName]);
          gameDate = this.Documents[i].date;
          this.$store.commit("report/setValue", ["gameDate", gameDate]);
          this.$store.commit("game/setValue", [
            "videoLink",
            this.Documents[i].videoLink
          ]);
        }
      }
      // console.log(
      //   "selected sponsor game video link: " +
      //     JSON.stringify(this.videoOptions, null, 2)
      // );
    },
    initializePage() {
      //set the sponsorID from the store to the one associated with the user
      this.readGames();
      this.$store.commit("report/setValue", ["sponsorID", this.user.sponsorID]);
      //display games in select for the current sponsor
      this.sortGamesBySponsor();
      this.sortGamesByDate();
      this.sortedGames = this.games;
      // console.log("I am here with sponsor: " + this.user.sponsorID);
      // set the sponsorName with the one associated to the sponsorID
      for (var i = 0; i < this.Sponsors.length; i++) {
        if (this.user.sponsorID === this.Sponsors[i].id) {
          this.$store.commit("report/setValue", [
            "sponsorName",
            this.Sponsors[i].name
          ]);
          // console.log("Sponsor name: " + this.sName);
        }
      }
      //set the gameID to the one associated with the sponsorID
      //cond display latest game : sort by date
      var docs = this.games;
      for (var i = 0; i < this.Documents.length; i++) {
        for (var j = 0; j < this.Documents[i].sponsorID.length; j++) {
          if (this.user.sponsorID === this.Documents[i].sponsorID[j]) {
            docs.push(this.Documents[i]);
            // console.log("Sponsor in game: " + this.Documents[i].id);
          }
        }
      }
      //change the video link dynamically
      for (var i = 0; i < this.Documents.length; i++) {
        if (this.gameID === this.Documents[i].id) {
          this.$store.commit("game/setValue", [
            "videoLink",
            this.Documents[i].videoLink
          ]);
        }
      }
      // console.log(
      //   "sponsor game video link: " + JSON.stringify(this.videoOptions, null, 2)
      // );
      //docs - sorted games by SPONSOR ID AND GAME ID
      this.$store.commit("report/setValue", ["gameID", docs[0].id]);
      this.$store.commit("report/setValue", ["gameName", docs[0].gameName]);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.readSponsors();

    //check the user level
    if (parseInt(this.user.userLevel) === 10) {
      this.initializePage();
    } else {
      this.readGames();
    }
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #222c68 !important;
}

.device-main-game-report {
  position: absolute;
  /*z-index: 100 !important;*/
  width: 100% !important;
  left: 0px;
}

.game-card {
  width: 150px;
  height: 150px;
}

.game-title {
  text-align: left;
}

.back-btn {
  margin: auto;
  text-align: right;
}
.sponsors-container {
  margin: 0 !important;
  padding-top: 5px !important;
  padding-bottom: 0px !important;
  max-width: 100% !important;
}

.sponsor-list {
  margin-top: 7%;
  margin-left: 2%;
}

.sponsor-name {
  position: absolute;
  bottom: 0;
  padding: 0 !important;
  text-align: center;
  font-size: 14px;
  height: 20px !important;
}

.sponsor-icon {
  margin-top: 10%;
  font-size: 100px !important;
}

.sponsor-title-bar {
  padding: 0 !important;
}

.club-page-container {
  padding: 0 !important;
}

.page-title {
  letter-spacing: normal !important;
  font-family: Roboto, sans-serif !important;
  font-size: 18px !important;
  padding-top: 15px;
}

.individual-spon-btn {
  padding-bottom: 5% !important;
}

.sponsor-report-table .vgt-table.condensed td,
.vgt-table.condensed th.vgt-row-header {
  padding: 0.4em 1.4em 0.4em 0.4em !important;
  font-size: 14px !important;
}

.sponsor-report-table .vgt-table th {
  padding: 0.2em 0.2em 0.2em 0.2em !important;
}

.v-item-group.v-bottom-nav--fixed {
  z-index: 2 !important;
}

@media only screen and (max-width: 959px) {
  .game-player {
    height: 430px !important;
  }
  .display-1 {
    font-size: 26px !important;
  }
  .individual-spon-btn {
    padding-bottom: 0px !important;
  }
}

@media only screen and (max-width: 700px) {
  .game-player {
    height: 230px !important;
  }
  .display-1 {
    font-size: 20px !important;
  }
  .individual-spon-btn {
    padding-bottom: 0px !important;
  }
}

@media only screen and (max-width: 390px) {
  .game-player {
    height: 205px !important;
  }
  .display-1 {
    font-size: 16px !important;
  }
  .individual-spon-btn {
    padding-bottom: 0px !important;
  }
}
</style>


